var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-blueprints-tab"},[_c('ItemInventory',{attrs:{"items":_vm.items,"showTooltip":false},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }